import { Link } from 'react-router-dom';
import { hotArticles } from '@/mocks/homeData';

export default function HotArticleList() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              热门<span className="text-accent-500">大瓜</span>
            </h2>
            <p className="text-foreground-500 text-sm mt-2">全网最火爆料，每一口都是真瓜</p>
          </div>
          <Link
            to="/category/star-gossip"
            className="hidden sm:flex items-center gap-1 text-primary-500 text-sm font-medium hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Articles List */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {hotArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-2xl border border-secondary-200/60 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              {/* Image */}
              <div className="relative h-44 md:h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                {/* Rank Badge */}
                <div className="absolute top-3 left-3 w-7 h-7 rounded-lg bg-primary-500/90 backdrop-blur-sm flex items-center justify-center text-white text-xs font-bold">
                  {index + 1}
                </div>
                {/* Category Badge */}
                <div className="absolute top-3 right-3">
                  <span className="px-2.5 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-foreground-700 text-xs font-medium">
                    {article.category}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 mb-3">
                  {article.title}
                </h3>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3 text-foreground-400 text-xs">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i> {(article.views / 10000).toFixed(0)}万
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line"></i> {article.comments}
                    </span>
                  </div>
                  <span className="text-foreground-300 text-xs">{article.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Mobile View All */}
        <div className="mt-6 flex sm:hidden justify-center">
          <Link
            to="/category/star-gossip"
            className="whitespace-nowrap inline-flex items-center gap-1 px-5 py-2.5 rounded-full border border-primary-300 text-primary-500 text-sm font-medium hover:bg-primary-50 transition-colors cursor-pointer"
          >
            查看全部大瓜 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}